



import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import { inRange } from './util';

@Component({
    components: {},
})
export default class VueJsModalResizer extends Vue {
    private clicked = false;
    private size = {};

    @Prop({ type: [Number], default: 0 })
    private minHeight: number;

    @Prop({ type: [Number], default: 0 })
    private minWidth: number;

    private mounted() {
        this.$el.addEventListener('mousedown', this.start, false);
    }

    get className() {
        return { 'vue-modal-resizer': true, clicked: this.clicked };
    }

    private start(event) {
        this.clicked = true;

        window.addEventListener('mousemove', this.mousemove, false);
        window.addEventListener('mouseup', this.stop, false);

        event.stopPropagation();
        event.preventDefault();
    }
    private stop() {
        this.clicked = false;

        window.removeEventListener('mousemove', this.mousemove, false);
        window.removeEventListener('mouseup', this.stop, false);

        this.$emit('resize-stop', {
            element: this.$el.parentElement,
            size: this.size,
        });
    }
    private mousemove(event) {
        this.resize(event);
    }
    private resize(event) {
        const el = this.$el.parentElement;

        if (el) {
            let width = event.clientX - el.offsetLeft;
            let height = event.clientY - el.offsetTop;

            width = inRange(this.minWidth, window.innerWidth, width);
            height = inRange(this.minHeight, window.innerHeight, height);

            this.size = { width, height };
            el.style.width = width + 'px';
            el.style.height = height + 'px';

            this.$emit('resize', {
                element: el,
                size: this.size,
            });
        }
    }
}
